module.exports = __webpack_public_path__ + "static/media/14_4.132db0da.png";